import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
  isallowedview: boolean;
  isallowedcreate: boolean;
  isallowededit: boolean;
  isalloweddelete: boolean;
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    state: 'dashboard',
    name: 'Dashboard',
    type: 'link',
    icon: 'ti-home',
    
    isallowedview: true,
    isallowedcreate: true,
    isallowededit: true,
    isalloweddelete: true,
    children: []
  },
  {
    state: 'mapping',
    name: 'Mapping',
    type: 'sub',
    icon: 'ti-direction-alt',
    isallowedview: true,
    isallowedcreate: true,
    isallowededit: true,
    isalloweddelete: true,
    children: [
      {
        state: 'vehicle-mapping',
        name: 'Vehicle Mapping',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'fleet-mapping',
        name: 'Fleet Mapping',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true

      }
    ]
  },
  {
    state: 'reports',
    name: 'Reports',
    type: 'sub',
    icon: 'ti-receipt',
    isallowedview: true,
    isallowedcreate: true,
    isallowededit: true,
    isalloweddelete: true,
    children: [
      {
        state: 'vehicle-detail',
        name: 'Vehicle Detail Report',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'fleet-detail',
        name: 'Fleet Detail Report',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      }
    ]
  },
  {
    state: 'administration',
    name: 'Administration',
    type: 'sub',
    icon: 'ti-user',
    isallowedview: true,
    isallowedcreate: true,
    isallowededit: true,
    isalloweddelete: true,
    children: [
      {
        state: 'account',
        name: 'Account',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: false,
        isalloweddelete: false
      },
      {
        state: 'user',
        name: 'Users',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'fleet',
        name: 'Fleet',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'vehicle',
        name: 'Vehicle',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'geozone',
        name: 'Geozone',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'change-password',
        name: 'Change Password',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'scheduler-admin',
        name: 'Scheduler Admin',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'role-management',
        name: 'Role Management',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'role-access',
        name: 'Role Access Setup',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      }
    ]
  },
  {
    state: 'master',
    name: 'Master',
    type: 'sub',
    icon: 'ti-view-grid',
    isallowedview: true,
    isallowedcreate: true,
    isallowededit: true,
    isalloweddelete: true,
    children: [
      {
        state: 'time-zone',
        name: 'Time-Zone',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'country',
        name: 'Country',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'state',
        name: 'State',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'city',
        name: 'City',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'lookuptype',
        name: 'Lookup Type',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      },
      {
        state: 'lookup',
        name: 'Lookup',
        type: 'link',
        icon: 'ti-direction-alt',
        isallowedview: true,
        isallowedcreate: true,
        isallowededit: true,
        isalloweddelete: true
      }
    ]
  },
  {
    state: 'profile',
    name: 'Profile',
    type: 'other',
    icon: 'ti-user',
    isallowedview: true,
    isallowedcreate: true,
    isallowededit: true,
    isalloweddelete: true
  }
];

@Injectable()
export class MenuItems {
  getAll(): MainMenuItems[] {
    return MENUITEMS;
  }

  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
}



// WEBPACK FOOTER //
// ./src/app/shared/menu-items/menu-items.ts